import React, { useEffect, useState } from "react";
import moment from "moment";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import PdfSuratJalanManual from "../../components/PdfSuratJalanManual/PdfSuratJalanManual";
import PoSuratJalanManualPopup from "./PoSuratJalanManual";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import CloseLogo from "../../Assets/close_icon.png";
import RefreshIcon from "../../Assets/refresh-icon.png";
import SearchLogo from "../../Assets/search-icon.png";
import { postAxios } from "../../util/apiCall";

const safeName = (s) => String(s).replace(/[\\/:*?"<>|]/g, "-");

/* =========================================================
   SUB-MENU "SJ Manual": riwayat Surat Jalan yang dibuat manual
   (data dari collection PO.suratJalanManual, terpisah dari SJ yang ada PO-nya)
   ========================================================= */
export default function PoSuratJalanManualTab({ po }) {
  const { dataUser, checkingRole } = po;

  const [bulanFilter, setBulanFilter] = useState(
    moment().utcOffset("+0700").format("YYYY-MM")
  );
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");
  const [refresh, setRefresh] = useState(0);
  const [openManual, setOpenManual] = useState(false);

  // cancel SJ manual
  const [cancelTarget, setCancelTarget] = useState(null);
  const [cancelReason, setCancelReason] = useState("");
  const [cancelError, setCancelError] = useState("");

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/suratJalanManual`,
      { tim: dataUser.tim, type: "list", filterDate: bulanFilter },
      dataUser.auth,
      setRows,
      ""
    );
  }, [bulanFilter, refresh]);

  const list = Array.isArray(rows) ? rows : [];
  const q = search.trim().toLowerCase();
  const filtered = q
    ? list.filter((r) =>
        [
          r.noSj,
          r.yth,
          r.attnNama,
          r.noPol,
          ...(r.items || []).map((i) => i.namaBarang),
        ]
          .filter(Boolean)
          .some((v) => String(v).toLowerCase().includes(q))
      )
    : list;

  const openCancel = (r) => {
    setCancelTarget(r);
    setCancelReason("");
    setCancelError("");
  };
  const closeCancel = () => setCancelTarget(null);

  const submitCancel = () => {
    if (!cancelReason.trim())
      return setCancelError("Alasan cancel wajib diisi.");
    const target = cancelTarget;
    const reason = cancelReason.trim();
    const by = dataUser.name || dataUser.role;

    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/suratJalanManual`,
      {
        tim: dataUser.tim,
        type: "cancel",
        id: target._id,
        reason,
        cancelledBy: by,
      },
      dataUser.auth,
      "",
      ""
    );
    // langsung merah di layar; data asli ditarik ulang sebentar lagi
    setRows((prev) =>
      (Array.isArray(prev) ? prev : []).map((x) =>
        x._id === target._id
          ? {
              ...x,
              isCancelled: true,
              cancelReason: reason,
              cancelledBy: by,
              cancelledAt: new Date().toISOString(),
            }
          : x
      )
    );
    closeCancel();
    setTimeout(() => setRefresh((n) => n + 1), 800);
  };

  const download = async (r) => {
    const blob = await pdf(
      <PdfSuratJalanManual
        noSj={r.noSj}
        date={r.date}
        noPol={r.noPol}
        yth={r.yth}
        attnNama={r.attnNama || ""}
        attn={r.attn}
        telp={r.telp}
        items={r.items || []}
      />
    ).toBlob();
    saveAs(
      blob,
      `${safeName(r.noSj)} ${safeName(r.yth)} ${moment(r.date).format(
        "DD-MM-YY"
      )}.pdf`
    );
  };

  return (
    <>
      <div className="po-toolbar">
        <div className="po-toolbar-group">
          <input
            className="po-input po-input--date"
            type="month"
            value={bulanFilter}
            onChange={(e) => setBulanFilter(e.target.value)}
          />
          <div className="po-search">
            <input
              className="po-search-input"
              type="text"
              placeholder="Cari No. SJ / tujuan / No. Pol / barang"
              style={{ width: 280 }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <p className="po-search-icon">
              <img src={SearchLogo} alt="cari" />
            </p>
          </div>
          <img
            className="po-refresh"
            src={RefreshIcon}
            alt="refresh"
            onClick={() => setRefresh((n) => n + 1)}
          />
        </div>
        <div className="po-toolbar-group">
          <span className="po-summary">
            <b>{filtered.length}</b> surat jalan
            {filtered.some((r) => r.isCancelled)
              ? ` (${filtered.filter((r) => r.isCancelled).length} dibatalkan)`
              : ""}
          </span>
          {checkingRole ? (
            <button
              className="po-btn po-btn--manual"
              onClick={() => setOpenManual(true)}
            >
              Buat SJ Manual
            </button>
          ) : null}
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="po-empty">
          Belum ada surat jalan manual pada bulan ini.
        </div>
      ) : (
        <div className="po-sj-list">
          {filtered.map((r) => (
            <div
              className={`po-sj-card po-sj-card--manual ${
                r.isCancelled ? "po-sj-card--cancelled" : ""
              }`}
              key={r._id || r.noSj}
            >
              <div className="po-sj-head">
                <div className="po-sj-meta">
                  <button
                    className="po-link"
                    style={
                      r.isCancelled
                        ? undefined
                        : { color: "var(--po-manual-text)" }
                    }
                    disabled={r.isCancelled}
                    onClick={() => download(r)}
                  >
                    {r.noSj}
                  </button>
                  <span className="po-badge po-badge--manual">MANUAL</span>
                  {r.isCancelled ? (
                    <span className="po-badge po-badge--cancelled">
                      DIBATALKAN
                    </span>
                  ) : null}
                  {r.customerCode ? (
                    <span className="po-badge">{r.customerCode}</span>
                  ) : null}
                  <span>{moment(r.date).format("DD-MM-YYYY")}</span>
                  <span>
                    Yth. <b>{r.yth}</b>
                  </span>
                  {r.noPol ? <span>No. Pol: {r.noPol}</span> : null}
                  <span>
                    <b>{(r.items || []).length}</b> item
                  </span>
                  {r.createdBy ? (
                    <span className="po-summary">oleh {r.createdBy}</span>
                  ) : null}
                </div>
                <div className="po-toolbar-group">
                  {checkingRole && !r.isCancelled ? (
                    <button
                      className="po-btn po-btn--outline-danger po-btn--sm"
                      onClick={() => openCancel(r)}
                    >
                      Cancel SJ
                    </button>
                  ) : null}
                  <button
                    className="po-btn po-btn--manual po-btn--sm"
                    disabled={r.isCancelled}
                    onClick={() => download(r)}
                  >
                    Download PDF
                  </button>
                </div>
              </div>
              {r.isCancelled ? (
                <div className="po-sj-sub po-sj-sub--cancel">
                  <span>
                    <b>DIBATALKAN</b> — {r.cancelReason}
                  </span>
                  <span>
                    oleh {r.cancelledBy || "-"}
                    {r.cancelledAt
                      ? ` · ${moment(r.cancelledAt)
                          .utcOffset("+0700")
                          .format("DD-MM-YYYY HH:mm")}`
                      : ""}
                  </span>
                </div>
              ) : null}
              {r.attnNama || r.attn || r.telp ? (
                <div className="po-sj-sub">
                  {r.attnNama ? <span>Attn: {r.attnNama}</span> : null}
                  {r.attn ? <span>Alamat: {r.attn}</span> : null}
                  {r.telp ? <span>Telp: {r.telp}</span> : null}
                </div>
              ) : null}
              <table className="po-table">
                <thead>
                  <tr>
                    <th className="po-th" style={{ width: 44 }}>
                      No.
                    </th>
                    <th className="po-th" style={{ width: 140 }}>
                      Quantity
                    </th>
                    <th className="po-th">Nama Barang</th>
                    <th className="po-th">Keterangan</th>
                  </tr>
                </thead>
                <tbody>
                  {(r.items || []).map((it, k) => (
                    <tr
                      key={k}
                      className={`po-row ${k % 2 ? "po-row--alt" : ""} ${
                        r.isCancelled ? "po-row--cancelled" : ""
                      }`}
                    >
                      <td className="po-td">{k + 1}.</td>
                      <td className="po-td po-nowrap">
                        <b>{it.quantity}</b> {it.satuan}
                      </td>
                      <td className="po-td" style={{ whiteSpace: "pre-line" }}>
                        {it.namaBarang}
                      </td>
                      <td className="po-td">{it.keterangan}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      )}

      {cancelTarget ? (
        <PopUpComponent className="po-modal po-modal--sm po-modal--cancel">
          <div className="po-modal-head">
            <h3 className="po-modal-title">Cancel Surat Jalan Manual</h3>
            <img
              style={{ width: 36, height: 36, cursor: "pointer" }}
              src={CloseLogo}
              alt="tutup"
              onClick={closeCancel}
            />
          </div>
          <p className="po-hint po-hint--warn">
            SJ <b>{cancelTarget.noSj}</b> ({cancelTarget.yth}) akan ditandai
            dibatalkan. Nomor SJ tidak dipakai ulang dan PDF-nya tidak bisa
            diunduh lagi.
          </p>
          <label className="po-label">Alasan cancel</label>
          <textarea
            className="po-textarea"
            placeholder="Contoh: salah input barang, kendaraan batal berangkat, dll."
            value={cancelReason}
            onChange={(e) => setCancelReason(e.target.value)}
          />
          {cancelError ? <p className="po-error">{cancelError}</p> : null}
          <div className="po-actions-end">
            <button className="po-btn po-btn--ghost" onClick={closeCancel}>
              Kembali
            </button>
            <button className="po-btn po-btn--danger" onClick={submitCancel}>
              Ya, Cancel SJ
            </button>
          </div>
        </PopUpComponent>
      ) : null}

      {openManual ? (
        <PoSuratJalanManualPopup
          dataUser={dataUser}
          onClose={() => setOpenManual(false)}
          onCreated={() => setRefresh((n) => n + 1)}
        />
      ) : null}
    </>
  );
}
